<template>
  <div>
      <div v-if="failed" class="bg-red-lightest border border-red-light text-red-dark px-4 my-2 py-3 rounded relative" role="alert">
        <strong class="font-bold">Oh no!</strong>
        <div v-for="error in errors" :key="error" class="block sm:inline">{{ error }} 🤷‍♂️</div>
        <router-link tag="a" :to="{ name: 'Startseite' }" class="block mt-4 text-black font-bold">Zur Startseite</router-link>
      </div>
      <div v-if="!failed">
        <h1>Gruppenbestellung bei {{ officeOrder.hostName }}</h1>
        Du wurdest eingeladen um gemeinsam bei <strong>{{ officeOrder.hostName }}</strong> zu bestellen.<br />
        Lege die gewünschten Artikel in den Warenkorb und schließe deine Bestellung ab.<br />
        Dein Warenkorb landet anschließend im Warenkorb des Hauptbestellers.

        <form v-on:submit.prevent="join">
          <div class="mt-4 max-w-sm">
            <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-first-name">
              Dein Name
            </label>
            <input type="text" autocomplete="name" v-model="name" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" placeholder="" />
            <input type="submit" value="zur Speisekarte!" class="mt-2 bg-green-heinz hover:bg-green-heinz-dark text-white py-4 px-2 mb-8 w-full rounded hover:cursor-pointer" />
          </div>
        </form>
      </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Buerobestellung',

  data () {
    return {
      failed: false,
      errors: [],
      name: (this.item_vorname ? this.item_vorname + ' ' + this.item_name : ''),
      data: {}
    }
  },

  computed: {
    ...mapGetters([
      'token',
      'officeOrder',
      'content.item_vorname',
      'content.item_name',
      'isLoggedIn',
      'user'
    ])
  },

  created () {
    this.fillNameIfLoggedIn()

    axios.post(endpoints.joinOfficeOrder, {
      id: this.$route.params.officeId,
      uid: this.$route.params.officeUid
    })
      .then(({data}) => {
        this.failed = !data.success
        this.errors = data.errors

        if (data.success) {
          this.data = data
          this.setOfficeOrderHostId({
            hostId: data.hostId
          })
        }
      })
  },

  watch: {
    isLoggedIn: function () {
      this.fillNameIfLoggedIn()
    }
  },

  methods: {
    ...mapActions([
      'setOfficeOrderHostId'
    ]),

    ...mapMutations([
      'setOfficeOrderUsername',
      'resetPaymentMethod'
    ]),

    fillNameIfLoggedIn () {
      if (this.isLoggedIn) {
        this.name = this.user.item_firstname + ' ' + this.user.item_lastname
      }
    },

    join (event) {
      if (event) event.preventDefault()
      if (this.name === '') {
        alert('Bitte gib deinen Namen ein um mitbestellen zu können')
        return
      }

      if (!this.failed) {
        this.resetPaymentMethod()
        this.setOfficeOrderUsername(this.name)
        axios.post(endpoints.setOfficeOrderClientName, {
          name: this.name
        })
          .then(() => {
            window.location.href = this.data.hostUrl
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/officeorder/index.vue